<bz-table uniqueId="threepl-train-voucher-containers"
          appBringozIdGenerator="threepl-voucher-containers-table"
          [items]="containers()"
          [rowHeight]="80"
          [resizable]="false">
  <ng-template bzTableHeader>
    <div class="th col-order">{{ 'Order' | translate }}</div>
    <div class="th col-car">{{ 'Car' | translate }}</div>
    <div class="th col-container">{{ 'Container' | translate }}</div>
    <div class="th col-un">{{ 'UN' | translate }}</div>
    <div class="th col-material">{{ 'Material Code' | translate }}</div>
    <div class="th col-weight">{{ 'Weight' | translate }}</div>
    <div class="th col-package">{{ 'Package' | translate }}</div>
    <div class="th col-container-type">{{ 'Container Type' | translate }}</div>
    <div class="th col-packing-group">{{ 'Packing Groups' | translate }}</div>
    <div class="th col-flag">{{ 'Is Empty' | translate }}</div>
    <div class="th col-flag">{{ 'Linked Containers' | translate }}</div>
    <div class="th col-flag">{{ 'Middle Container' | translate }}</div>
    <div class="th col-flag">{{ 'Container Weighted' | translate }}</div>
    <div class="th col-flag">{{ 'Statement' | translate }}</div>
    <div class="th col-flag"></div>
  </ng-template>

  <ng-template bzTableRow let-container let-index="index">
    <app-threepl-train-voucher-containers-table-row appBringozIdGenerator="threepl-voucher-containers-table-row"
                                                    [container]="container"
                                                    [cars]="cars()"
                                                    [isSharedCar]="sharedCarsMap()[container.carId]"
                                                    [hazardousMaterials]="hazardousMaterials()"
                                                    [unNumbers]="unNumbers()"
                                                    [isEdit]="isEdit()"
                                                    [submitted]="submitted()"
                                                    (containerChange)="changeContainer.emit({container: $event, index: index})"
                                                    (isSharedCarChange)="isSharedCarChange.emit($event)"
                                                    (remove)="removeContainer.emit({container: $event, index: index})">
    </app-threepl-train-voucher-containers-table-row>
  </ng-template>

  <bz-empty-state bzTableEmptyState
                  [title]="'No Containers Found' | translate"
                  image="assets/images/empty_state/empty_state_dispatching.png">
  </bz-empty-state>
</bz-table>
